import React from 'react';
import styled from 'styled-components';

import { IProduct } from 'models';

interface IProps {
  products: IProduct[];
  productSelected: (product: IProduct) => void;
}

interface IState {
  selectedProduct: IProduct;
}

const TableContainer = styled.div`
  overflow-x: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  flex-wrap: wrap;
`;

const Table = styled.table`
  width: 95%;
  max-width: 640px;
  overflow: auto;
  border-collapse: collapse;
  z-index: 1;
`;

const ButtonContainer = styled.div`
  overflow: auto;
  display: flex;
  max-width: 640px;
  flex-direction: row;
  align-items: stretch;
  width: 95%;
`;

const Button = styled.button<{ selected: boolean }>`
  border: 1px solid #DDD;
  padding: 16px 8px;
  margin-bottom: 8px;
  font-size: calc(0.6em + 0.5vw);
  background: white;
  flex: 1 1 0;
  transition: background-color 0.2s ease, color 0.2s ease;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;

  background-color: ${(props) => props.selected ? '#FF7203' : 'white'};
  color: ${(props) => props.selected ? 'white' : 'black'};
  outline: ${(props) => props.selected ? 'none' : ''};

  :hover {
      cursor: pointer;
      background-color: #FF7203;
      color: white;
  }

  :focus {
      background-color: #FF7203;
      color: white;
      outline: none;
  }
`;

const Td = styled.td`
  height: 53px;
  border: 1px solid #DDD;
  padding: 10px;
  empty-cells: show;
  text-align: left;
  display: table-cell;
  position: relative;
`;

const KeyTd = styled.td`
  height: 53px;
  border: 1px solid #DDD;
  flex-wrap: wrap;
  padding: 10px;
  empty-cells: show;
  text-align: left;
  font-weight: bold;
  display: table-cell;
  column-span: 2;
`;

class CompactResultTable extends React.Component<IProps, IState> {

  constructor(props: IProps) {
    super(props);
    this.state = {
      selectedProduct: this.props.products[0]
    };
  }

  componentDidMount() {
    this.props.productSelected(this.props.products[0]);
  }

  render() {
    const { products, productSelected } = this.props;
    const { selectedProduct } = this.state;

    const productClicked = (selectedProduct: IProduct) => {
      this.props.productSelected(selectedProduct);
      this.setState({
        selectedProduct
      });
    };

    const exists = (existing: Array<{ key: string, value: string, unit?: string }>, key: string) => {
      return existing.find((x) => x.key === key) != null;
    };

    const getFormattedMetadata = (metadata: Array<{ key: string, value: string, unit?: string }>) => {
      const formattedData = new Array<{ key: string, value: string, unit?: string }>();
      const excludedKeys = ['engine-id'];

      metadata.forEach((data) => {
        if (!excludedKeys.includes(data.key)) {
          if (!exists(formattedData, data.key)) {
            formattedData.push({ ...data });
          } else {
            if (!formattedData[formattedData.findIndex((x) => x.key === data.key)].value.includes(data.value)) {
              formattedData[formattedData.findIndex((x) => x.key === data.key)].value += ` / ${data.value}`;
            }
          }
        }
      });

      return formattedData;
    };

    return (
      <TableContainer>
        <ButtonContainer>
          {
            products.map((product) => {
              return (
                <Button
                  key={product.name}
                  selected={product === this.state.selectedProduct}
                  onClick={() => productClicked(product)}
                >
                  {product.name}
                </Button>
              );
            })
          }
        </ButtonContainer >
        < Table >
          <thead>
            <tr>
              <th />
            </tr>
          </thead>
          {
            getFormattedMetadata(products[0].metadata).map((data) => {
              return (
                <tr key={data.key}>
                  <KeyTd key={data.key}>
                    {data.key}
                  </KeyTd>
                  <Td key={selectedProduct.name} onClick={() => productSelected(selectedProduct)}>
                    {
                      `${getFormattedMetadata(selectedProduct.metadata).filter(
                        function (item) {
                          return item.key === data.key;
                        })[0].value || ''} ${selectedProduct.metadata.filter(
                          function (item) { return item.key === data.key; })[0].unit || ''}`
                    }
                  </Td>
                </tr>
              );
            })
          }
        </Table >
      </TableContainer >
    );
  }
}

export default CompactResultTable;
